import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import { OrgPermissions } from '../types/permissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  permission?: keyof OrgPermissions; // if set, redirect to /dashboard if user lacks this permission
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, permission }) => {
  const { user, loading, permissions } = useAuth();
  const { can } = usePermissions();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Permission gate: if permissions are loaded and the user lacks this permission, deny access
  if (permission && permissions && !can(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
